import { ShiftRosterTableVolunteer } from '../../../../../ui/features/shift-roster-table';
import { useMissionsTranslation } from '../../../../../ui/hooks';
import { formatPhoneNumber } from '@juvare/common-phone-number';
import { Box } from '@mui/material';
import React from 'react';
export const ShiftDetailsTablesVolunteer = ({ shift, participants }) => {
    const { t } = useMissionsTranslation();
    const approvedRequests = participants.rows.filter((row) => row.columns.status === 'approved');
    const formatContacts = (participants) => {
        return participants.map((participant) => {
            if (!participant.columns.showContactInfo) {
                const participantEmail = t('shifts.rosterTable.emailIsHidden');
                const participantContactInfo = t('shifts.rosterTable.contactIsHidden');
                return Object.assign(Object.assign({}, participant), { columns: Object.assign(Object.assign({}, participant.columns), { participantEmail, participantContactInfo }) });
            }
            else if (!!participant.columns.participantContactInfo) {
                const participantContactInfo = formatPhoneNumber(participant.columns.participantContactInfo);
                return Object.assign(Object.assign({}, participant), { columns: Object.assign(Object.assign({}, participant.columns), { participantContactInfo }) });
            }
            return Object.assign({}, participant);
        });
    };
    if (approvedRequests.length > 0) {
        return (React.createElement(Box, { display: 'flex', flexDirection: 'column', gap: 6, sx: { p: 2 } },
            React.createElement(ShiftRosterTableVolunteer, { totalApprovedRequests: approvedRequests.length, numberOfRequiredParticipants: getTotalNumberOfRequiredParticipants(shift), approvedRequests: formatContacts(approvedRequests) })));
    }
    return null;
};
function getTotalNumberOfRequiredParticipants(shift) {
    let totalNumberOfRequiredParticipants = 0;
    shift.data.positions.forEach((position) => {
        totalNumberOfRequiredParticipants += position.quantity;
    });
    return totalNumberOfRequiredParticipants;
}
